// Блок 6: Демо — интерактивный 3-column comparison experience

import { DemoExperience } from '../demo/DemoExperience';

export function DemoSection(): JSX.Element {
  return (
    <section id="demo" className="py-20 lg:py-28 bg-surface-subtle">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight">
            Попробуйте прямо сейчас
          </h2>
          <p className="mt-4 text-text-secondary text-base sm:text-lg leading-relaxed">
            Напишите вопрос от лица клиента, затем ответьте как оператор —
            и&nbsp;посмотрите, насколько Anima угадала.
          </p>
        </div>

        {/* Interactive demo */}
        <div className="max-w-5xl mx-auto">
          <DemoExperience />
        </div>

        {/* Bottom text */}
        <div className="text-center mt-8">
          <p className="text-sm text-text-muted">
            Это реальный AI, обученный на знаниях о нашем продукте.
            Представьте, что он обучен на знаниях о&nbsp;вашем.
          </p>
        </div>
      </div>
    </section>
  );
}
